var settingsBreakpointMobile = '600px';
var textsEl = document.querySelector(`.section-expert-recommendations .expert-texts`);
var imagesEl = document.querySelector(`.section-expert-recommendations  .expert-images`);

const textSlider = new KeenSlider(textsEl, {
    mode: 'snap',
    controls: false,
    loop: true,
    autoplay: false,
    centered: true,
    spacing: 0,
    slidesPerView: 1
});

const imageSlider = new KeenSlider(imagesEl, {
    mode: 'snap',
    controls: false,
    loop: true,
    autoplay: false,
    centered: false,
    spacing: 0,
    breakpoints: {
        '(min-width: 601px)': {
            slidesPerView: 1
        },
        [`(max-width: ${settingsBreakpointMobile})`]: {  // Inject the breakpoint_mobile value here
            spacing: 20,
            // Keep margin with overflowed sides vs width and spacing (Figma slider container taking into account margin = around 327px)
            slidesPerView: 1.2
        }
    }
});

document.querySelectorAll(`.section-expert-recommendations .keen-arrow.prev`).forEach(prevArrow => {prevArrow.addEventListener("click", () => {textSlider.prev();imageSlider.prev();})});
document.querySelectorAll(`.section-expert-recommendations .keen-arrow.next`).forEach(forwArrow => {forwArrow.addEventListener("click", () => {textSlider.next();imageSlider.next();})});